/**
 * ASCII art frames for the AMETA logo animation.
 */

export const LOGO_LINES_WITHOUT_LAST_A = [
	' █████╗ ███╗   ███╗███████╗████████╗',
	'██╔══██╗████╗ ████║██╔════╝╚══██╔══╝',
	'███████║██╔████╔██║█████╗     ██║   ',
	'██╔══██║██║╚██╔╝██║██╔══╝     ██║   ',
	'██║  ██║██║ ╚═╝ ██║███████╗   ██║   ',
	'╚═╝  ╚═╝╚═╝     ╚═╝╚══════╝   ╚═╝   '
] as const;

export const LAST_A_LINES = [
	' █████╗ ',
	'██╔══██╗',
	'███████║',
	'██╔══██║',
	'██║  ██║',
	'╚═╝  ╚═╝'
] as const;

export const A_PERSON_FRAMES = {
	stand: [' █████╗ ', '██╔══██╗', '███████║', '██╔══██║', '██║  ██║', ' ▼    ▼ '],
	run1: [' █████╗ ', '██╔══██╗', '███████║', '██╔══██║', '██║  ██║', '▼      ▼'],
	run2: [' █████╗ ', '██╔══██╗', '███████║', '██╔══██║', '██║  ██║', ' ▼    ▼ '],
	cart1: ['   █████', '  ██══██', ' █████║ ', ' ██══▼  ', '██║     ', '▼       '],
	cart2: ['        ', '██╗  ╔██', '███████►', '██╚  ╝██', '        ', '        '],
	cart3: ['▲       ', '██║     ', ' ██══▲  ', ' █████║ ', '  ██══██', '   █████'],
	cart4: [' ▲    ▲ ', '██║  ██║', '██╚══██║', '███████║', '██╔══██╝', ' █████╝ '],
	cart5: ['       ▲', '     ██║', '  ▲══██ ', ' ║█████ ', '██══██  ', '█████   '],
	cart6: ['        ', '██╗  ╔██', '◄███████', '██╚  ╝██', '        ', '        '],
	cart7: ['█████   ', '██══██  ', ' ║█████ ', '  ▼══██ ', '     ██║', '       ▼']
} as const;

export type FrameKey = keyof typeof A_PERSON_FRAMES;

export interface AnimationFrame {
	frame: FrameKey;
	x: number;
	duration: number;
}

export const CARTWHEEL_ANIMATION_SEQUENCE: AnimationFrame[] = [
	{ frame: 'run1', x: 20, duration: 80 },
	{ frame: 'run2', x: 40, duration: 80 },
	{ frame: 'run1', x: 60, duration: 80 },
	{ frame: 'run2', x: 80, duration: 80 },
	{ frame: 'stand', x: 100, duration: 100 },
	{ frame: 'cart1', x: 110, duration: 80 },
	{ frame: 'cart2', x: 120, duration: 80 },
	{ frame: 'cart3', x: 130, duration: 80 },
	{ frame: 'cart4', x: 140, duration: 80 },
	{ frame: 'cart5', x: 150, duration: 80 },
	{ frame: 'cart6', x: 160, duration: 80 },
	{ frame: 'cart7', x: 170, duration: 80 },
	{ frame: 'stand', x: 180, duration: 100 },
	{ frame: 'run2', x: 140, duration: 80 },
	{ frame: 'run1', x: 100, duration: 80 },
	{ frame: 'run2', x: 60, duration: 80 },
	{ frame: 'run1', x: 30, duration: 80 },
	{ frame: 'stand', x: 0, duration: 100 }
];

export const ANIMATION_CONFIG = {
	totalColumns: 36,
	waveDuration: 1500,
	waveOffset: -8,
	waveResetDelay: 150
} as const;
